export default __webpack_public_path__ + "static/media/e-bupot-picturemark-l.d15c09de.svg";